import {
  Maybe,
  MembershipInfo,
  MembershipMagazine
} from '../../../../../utils/classes/graphql'
import {
  createKeysAndColumnNameArray,
  DenseTableRowProps,
  CellProps
} from '../../../../../components'
import { MembershipData } from '../types'

export const membershipKeysAndColumns: CellProps<MembershipData>[] =
  createKeysAndColumnNameArray('pages.ownInfoPage.membership.memberships.', [
    {
      key: 'jasenlaji',
      translationIdPostfix: 'type'
    },
    {
      key: 'ammattiosasto',
      translationIdPostfix: 'department'
    },
    {
      key: 'jasennumero',
      translationIdPostfix: 'memberId'
    },
    {
      key: 'liittymispvm',
      translationIdPostfix: 'startDate'
    }
  ])

export const MEMBERSHIP_MAGAZINES_KEY_MAGAZINE = 'lehti'
export const MEMBERSHIP_MAGAZINES_KEY_START_DATE = 'alkupvm'
export const MEMBERSHIP_MAGAZINES_KEY_END_DATE = 'loppupvm'

export const magazineKeysAndColumns: CellProps<MembershipMagazine>[] =
  createKeysAndColumnNameArray(
    'pages.ownInfoPage.membership.membershipMagazines.',
    [
      {
        key: 'lehti',
        translationIdPostfix: 'name'
      },
      {
        key: 'alkupvm',
        translationIdPostfix: 'startDate'
      },
      {
        key: 'loppupvm',
        translationIdPostfix: 'endDate'
      }
    ]
  )

export type MaybeMembershipInfo = Maybe<MembershipInfo> | undefined

export const createMembershipArray = (
  membershipInfo: MaybeMembershipInfo
): DenseTableRowProps<MembershipData>[] => {
  const jasenyys = membershipInfo?.jasenyys
  const membership = {
    jasennumero: membershipInfo?.jasennumero,
    jasenlaji: jasenyys?.jasenlaji,
    ammattiosasto: jasenyys?.ammattiosasto,
    liittymispvm: jasenyys?.liittymispvm
  }
  return [membership]
}
